import { useContext, useEffect } from "react";
import { Form, useNavigate, useSearchParams } from "react-router-dom";
import { AppContext } from "../App";
import logo from "../assets/images/logo.png";
import CardGrid from "../components/card/CardGrid";
import ChannelCard from "../components/card/ChannelCard";
import PlaceholderCard from "../components/card/PlaceholderCard";
import CategorySelect from "../components/CategorySelect";
import useInput from "../hooks/useInput";
import { range } from "../lib/range";
import magnifier from "../assets/images/search-outline.svg";
import { useRecommended } from "../hooks/useRecommended";
import VideoCard from "../components/card/VideoCard";
import useInfiniteScroll from "../hooks/useInfiniteScroll";

export default function Recommended() {
    const appContext = useContext(AppContext);
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();
    const [query, queryProps] = useInput(searchParams.get("k") || "");
    const [searchResult, isLoading, setCategory, loadMore] = useRecommended(
        appContext?.category
    );
    const hasReachedEnd = useInfiniteScroll(300);
    useEffect(() => {
        if (hasReachedEnd) loadMore();
    }, [hasReachedEnd]);

    useEffect(() => {
        if (appContext) {
            setCategory(appContext.category);
        }
    }, [appContext]);

    useEffect(() => {
        if (query) {
            const timeout = setTimeout(
                () => navigate("/search?k=" + query),
                500
            );
            return () => clearTimeout(timeout);
        }
    }, [query]);

    return (
        <div className="mt-4 flex w-11/12 flex-col items-center gap-6 md:mt-0 md:gap-6">
            <div className="flex flex-col gap-2 text-left md:gap-0 md:text-center">
                <p>
                    Seja bem vindo aos vídeos recomendados pelo{" "}
                    <b>Robozinho do XVIDEOS.</b>
                </p>
                <p>
                    Aqui você vai encontrar uma seleção dos melhores vídeos{" "}
                    <b>PREMIUM</b> do XVideos!
                </p>
            </div>

            <div className="flex w-full max-w-3xl flex-col items-center gap-4">
                {appContext && (
                    <div className="flex items-center gap-1 rounded-md border border-xv-border-color bg-xv-bg-2 pl-2">
                        <span>Categoria: </span>
                        <CategorySelect
                            categoryType={appContext.category}
                            setCategoryType={appContext.setCategory}
                        />
                    </div>
                )}
                {/* <Form action="/search" className="flex w-full px-[1px]">
                    <input
                        className="w-full rounded-l-full border border-xv-border-color bg-xv-bg-2 px-5 py-3 outline-none focus:border-xv-red"
                        placeholder="Pesquisar XVideos"
                        type="search"
                        name="k"
                        {...queryProps}
                    />
                    <button
                        className="rounded-r-full border border-xv-red bg-xv-red px-5 py-3 focus:outline-dotted focus:outline-1 hocus:brightness-90"
                        type="submit"
                    >
                        <img
                            className="h-6 w-6"
                            src={magnifier}
                            alt="Pesquisar"
                        />
                    </button>
                </Form> */}
            </div>
            <CardGrid>
                {[
                    ...(searchResult
                        ? searchResult.videos.map((video, i) => (
                              <VideoCard
                                  key={i}
                                  {...video}
                                  href={video.href}
                              />
                          ))
                        : []),

                    ...(isLoading
                        ? range(0, 8).map((i) => (
                              <PlaceholderCard
                                  key={
                                      (searchResult
                                          ? searchResult.videos.length
                                          : 0) + i
                                  }
                              />
                          ))
                        : []),
                ]}
            </CardGrid>
        </div>
    );
}
